import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const LockerBase = (
  <path
    fill='currentColor'
    d='M10.364 6.96H5.636V5.57c0-1.33 1.058-2.41 2.364-2.41 1.306 0 2.364 1.08 2.364 2.41V6.96zm-1.762 3.91l.137 1.577c0 .075-.06.136-.133.136h-1.07c-.073 0-.133-.06-.133-.136l.137-1.578c-.422-.204-.717-.639-.717-1.146 0-.703.56-1.272 1.248-1.272.69 0 1.248.57 1.248 1.272 0 .507-.294.942-.717 1.146zm3.234-3.91h-.332V5.57C11.504 3.6 9.935 2 8 2S4.496 3.599 4.496 5.571V6.96h-.332c-.367 0-.664.303-.664.677v5.687c0 .374.297.677.664.677h7.672c.367 0 .664-.303.664-.677V7.636c0-.374-.297-.677-.664-.677z'
  />
)

export const Locker = createIcon({
  displayName: 'Locker',
  viewBox: '0 0 16 16',
  path: LockerBase,
})
